import React, { PropsWithChildren } from "react";

// Shadows gatsby-theme-material-ui-top-layout's TopLayout. The plugin's default
// wraps the app in its own fixed light-mode ThemeProvider + CssBaseline, which
// shadows the toggleable theme provided by src/theme/Context and leaves
// inherited text colors stuck in light mode. Rendering children verbatim lets
// ThemeContextProvider be the single source of theme and CssBaseline.
export default function TopLayout({ children }: PropsWithChildren) {
  return <>{children}</>;
}
